module.exports = __webpack_public_path__ + "media/se_player_muteki.24d7d552.mp3";